// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetInfrastructureGeoObjectsRequest,
  TGetInfrastructureGeoObjectsModel,
  IMappers,
  TGetInfrastructureGeoObjectsResponse,
  TGetInfrastructureGeoObjectsResponse_1,
  TGetInfrastructureGeoObjectsResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TGetInfrastructureGeoObjectsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'infrastructure-caching',
  pathApi: '/v1/get-infrastructure-geo-objects/',
  interserviceAuthEnabled: true,
} as TGetInfrastructureGeoObjectsModel;

export function createGetInfrastructureGeoObjectsModel(
  parameters: IGetInfrastructureGeoObjectsRequest,
): TGetInfrastructureGeoObjectsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetInfrastructureGeoObjectsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetInfrastructureGeoObjectsRequest;
}

export async function fetchGetInfrastructureGeoObjects<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetInfrastructureGeoObjectsOptions<TResponse200, TResponse400>): Promise<
  TGetInfrastructureGeoObjectsResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createGetInfrastructureGeoObjectsModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGetInfrastructureGeoObjectsResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TGetInfrastructureGeoObjectsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetInfrastructureGeoObjectsResponse;
}
